module.exports = __webpack_public_path__ + "img/合作伙伴logo.ff4ab12a.png";